<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <span class="sy-im" @click="handleClick" v-if="isShow"  >
    <slot :unreadCount="unreadCount">
      <template v-if="!this.messageBoard">
        <span class="sy-im-icon"></span>
      </template>
      <template v-else>
        <span v-if="messageBoardType === 'text'" class="sy-im-list" :class="{active: this.unreadCount > 0}">
          <span class="iconfont icon-square"></span><em v-if="label">{{label}}</em>
        </span>
        <em v-else-if="messageBoardType === 'icon'" class="sy-im-list-icon font-color-primary_hover" :class="{active: this.unreadCount > 0}">
          <span class="iconfont icon-liuyanban1 sy-im-icon-list"></span>
        </em>
      </template>
    </slot>
  </span>
</template>

<style scoped lang="scss">
  .sy-im{
    display: inline-block;
    line-height: 16px;
    .sy-im-icon {
      width: 14px;
      height: 14px;
      display: inline-block;
      background: url($img-url + "162876955763420039.png") no-repeat right top;
      background-size: 29px 14px;
      cursor: pointer;
      &:hover {
        background-position: left top;
      }
    }

    .sy-im-list-icon{
      position: relative;
      cursor: pointer;
      &:hover{
        .sy-im-icon-list {
          color: currentColor;
        }
      }
      .sy-im-icon-list{
        position: relative;
        padding-right: 0px;
        font-size: 16px;
        color: #888;
      }
      &.active {
        &:after{
          width: 8px;
          height: 8px;
          background: #e60d0B;
          border-radius: 4px;
          top: -2px;
          margin-top: 0px;
          content: '\20';
          position: absolute;
          right: -3px;
        }
      }
    }
    .sy-im-list{
      position: relative;
      cursor: pointer;
      font: optional;
      .icon-square{
        vertical-align: middle;
      }
      &.active {
        &:after{
          width: 6px;
          height: 6px;
          background: #e60d0B;
          border-radius: 3px;
          top: 0;
          margin-top: 0px;
          content: '\20';
          position: absolute;
          right: 0px;
        }
      }
      em {
        vertical-align: middle;
        margin-left: 2px;
        padding-right: 8px;
      }
      font-size: 12px;
    }
  }
</style>

<script>
import Api from './api'
// import response from '../../../utils/response/index.js'
import cachedRequest from '../../../utils/cached-request'
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  data () {
    // console.log(this.clientType)
    return {
      // isShow: true,
      rule: {},
      enable: false,
      unreadCount: 0,
      timer: null
    }
  },
  props: {
    // 是否展示联系人列表
    showContentList: {
      type: Boolean,
      default: false
    },
    // 是否是留言板
    messageBoard: {
      type: Boolean,
      default: false
    },
    // 留言板模式
    messageBoardType: {
      type: String,
      default: 'icon' // icon text
    },
    // 单机类型
    applyFormCode: {
      type: String
    },
    // 发起端
    clientType: {
      type: String
    },
    // 接受端
    acceptClientType: {
      type: String
    },
    // 单据id
    acceptorId: {
      type: String
    },
    // 单据信息
    acceptorInfo: {
      type: Object
    },
    // 接受人信息
    toUserInfo: {
      type: Object
    },
    toSupplierName: {
      type: String
    },
    toSupplierId: {
      type: String
    },
    // 跳转参数
    extendParam: {
      type: Object,
      default: () => ({})
    },
    // 聊天人id
    toId: '',
    // icon label
    label: {
      type: String,
      default: '留言板'
    }
  },
  created () {
    // console.log(this.$route)
    // console.log(this.messageBoard, 'aaaa')
    if (this.messageBoard) {
      this.checkImAuthority()
    } else {
      this.getRule()
    }

    // this.$nextTick(function () {
    //   this.handleClick()
    // })
  },
  beforeDestroy: function () {
    // console.log(3333)
    // this.syIm.hide()
  },
  computed: {
    isShow: function () {
      if (this.messageBoard) {
        return this.enable
      } else {
        const ruleList = this.rule.synergyList || []
        return ruleList.some(item => {
          let acceptClientType = this.CLIENT_TYPE_CONST[this.acceptClientType].code
          let clientType = this.CLIENT_TYPE_CONST[this.clientType].code
          return (item.anotherSynergyCode === acceptClientType || item.oneSynergyCode === acceptClientType) && (item.anotherSynergyCode === clientType || item.oneSynergyCode === clientType)
        })
      }
    }
  },
  methods: {
    variableReplace (str, obj) {
      if (!obj) {
        return str
      }
      let re = /{([^{]*?)}/g
      // console.log('str, obj', str, obj)
      return typeof str === 'string'
        ? str.replace(re, function (key, group) {
          return (obj[group] !== undefined) ? obj[group] : key
        })
        : str
    },
    handleClick () {
      this.syIm.show({
        applyFormCode: this.applyFormCode,
        // 发起端
        clientType: this.CLIENT_TYPE_CONST[this.clientType].code,
        // 单据id
        acceptorId: this.acceptorId,
        acceptorInfo: this.acceptorInfo,
        toUserInfo: this.toUserInfo,
        buyerUrl: this.variableReplace(this.rule.buyerUrl, this.extendParam),
        demandUsersUrl: this.variableReplace(this.rule.demandUsersUrl, this.extendParam),
        supplierUrl: this.variableReplace(this.rule.supplierUrl, this.extendParam),
        applyFormName: this.rule.applyFormName,
        extendParam: JSON.stringify(this.extendParam),
        acceptClientType: this.acceptClientType,
        showContentList: this.showContentList,
        toSupplierName: this.toSupplierName,
        toSupplierId: this.toSupplierId,
        // 聊天人id
        toId: this.toId
      })
    },
    async checkImAuthority () {
      const api = Api.checkImAuthority
      const res = await cachedRequest(api, {
        appCode: 'im_message_board ',
        clientType: this.CLIENT_TYPE_CONST[this.clientType].code
      })
      if (res.isOk) {
        this.enable = res.content.enable
        this.unreadCount = res.content.unreadCount || 0
        if (!this.enable) {
          clearTimeout(this.timer)
        } else {
          this.timer = setTimeout(() => {
            this.checkImAuthority()
          }, 1000 * 60 * 2)
        }
      }
    },
    async getRule () {
      const api = Api.configList
      const res = await cachedRequest(api, {
        applyFormCode: this.applyFormCode,
        clientType: this.CLIENT_TYPE_CONST[this.clientType].code
      })
      if (res.isOk) {
        // console.log('res', res)
        this.rule = res.content
      }
    }
  }
}
</script>
